import React, { useEffect, useRef, useState } from "react"
import Box from "@mui/material/Box"
import TreatmentPlan from "../TreatmentPlan"
import { addFollowUP, cancelTest, getTestsList, getVitals, saveTest, sendTest, updateTest } from "../../core/services/api/patientDiagnosisService"
import { useSelector } from "react-redux"
import { checkIcdDrugInteraction } from "../../core/services/api/patientClinicalService"
import { MocUserRole } from "../../core/services/models/Enums"
import Select from "react-select"
import SurveyComponent from "pages/RMO/components/cancerTemplate/Template"
import PreviousFollowUpVisit from "./PreviousFollowUpVisit"
import moment from "moment"
import Modal from "react-bootstrap/Modal"
import Toast from "../../components/Toast"
import { getAllConsultantReferralDetails, getFollowUpDetails, getListCancerOrder, getManageStaffDetailsById, getSaveNurseNotes, getSelectedChemoOrder, saveNurseNotes, getServiceBasedOnCategory, uploadSpecificFile } from "../../core/services/api"
import Button from "../Button"
import InputField from "../InputField"
import "./FollowUpVisit.scss"
import testLabels from "./testLabels.json"
import PreviousFollowUpPrint from "./PreviousFollowUpPrint"
import Print from "components/Print/Print"

function FollowUpVisit({
  isEditable,
  ignoreAutopopulatedFollowUp = false,
  followUpResults,
  referredToDetails,
  setResFollowUpData,
  setIsFollowUpData,
  recordDetails,
  appointmentDetails,
  patientDetail,
  isReadOnly,
  id,
  staffType,
  smartSummaryData,
  scroll,
  consultantRequest = false
}: any) {
  const [formFollowUpErrors, setFormFollowUpErrors] = useState({})

  const [followUpData, setfollowUpData] = useState<any>({
    visitPad: "",
    advice: "",
    nextVisit: "",
    nextVisit1: "",
    nextVisit2: "",
  })
  const [isFollowUpSubmit, setIsFollowUpSubmit] = useState(false)
  const [isFetchAgain, setIsFetchAgain] = useState<boolean>(false)
  const referredTo = {
    doctorName: "",
    speciality: "",
    phoneNo: "",
    emailId: "",
  }
  let [referredTos, setReferredTos] = useState<any>([referredTo])


  const [consultantNotesData, setConsultantNotesData] = useState<any>({
    clinicalImpression: "",
    notes: "",
  })
  const serviceRendered = {
    serviceTemplateName: "",
    serviceTemplateId: "",
    completedBy: "",
  }
  const [servicesRendered, setServicesRendered] = useState([serviceRendered])
  const [servicesRenderedPrint, setServicesRenderedPrint] = useState<any>()
  const [treatmentTypes, setTreatmentTypes] = useState<any>([])

  const centerId = appointmentDetails?.centerId
  const consultantId = appointmentDetails?.consultantId
  const appointmentId = appointmentDetails?.id
  const appointmentType = appointmentDetails?.appointmentType
  const recordId = recordDetails?.id || id
  const patientId = appointmentDetails?.patientId
  const appointmentDate = appointmentDetails?.scheduleDate

  const userDetail = useSelector((state: any) => state?.user?.userDetail)
  const userRole = useSelector((state: any) => state?.user?.role)
  const followUpPrintRef = useRef(null)

  const [selectedOptionLoadChemo, setSelectedOptionLoadChemo] = useState<any>()
  const [orderTemplates, setOrderTemplates] = useState<any>([])

  const dropdownCancerOrder = orderTemplates.map((vals: any) => {
    return {
      label: `Cycle Number: ${vals?.cycleNo};  Date: ${vals?.chemoOrderForDate ? moment(vals?.chemoOrderForDate).format('DD/MM/YYYY') : 'Not available'}`,
      value: vals?.id
    }
  })

  useEffect(() => {
    getListCancerOrder(patientId)
      .then((res: any) => {
        console.log("cancer Order", res)
        setOrderTemplates(res)
      })
      .catch((err: any) => {
        console.log("coming to errorrrr", err)
      })
  }, [])

  //Prescriptions
  const prescriptionItem = {
    medicines: [{
      type: "",
      medicineName: "",
      dose: "",
      when: "",
      frequency: "",
      duration: "",
      instructions: "",
      isChosen: false,
      selectedSideEffects: []
    }],
    isCancelled: false,
    readyToSent: false,
    addToPrint: true
  }
  const [prescriptionPlans, setPrescriptionPlans] = useState<any>([prescriptionItem])
  //Tests
  const testRequest = {
    tests: [{
      serviceId: "",
      instructions: "",
      when: "",
      testName: ""
    }],
    isCancelled: false,
    isSent: false,
    addToPrint: true
  }
  const testItem = {
    serviceId: "",
    instructions: "",
    when: "",
    testName: ""
  }
  const [testsRequested, setTestsRequested] = useState<any>([testRequest])
  const [testsOptions, setTestsOptions] = useState<any>([])
  //Pop-ups
  const [open, setOpen] = useState(false)
  const [message, setMessage] = useState("")
  const [error, setError] = useState<boolean>(false)
  const [view, setView] = useState<boolean>(false)
  //Loader
  const [isLoading, setIsLoading] = useState<boolean>(false)
  //Referal Doctors
  const [referalConsultants, setReferalConsultants] = useState<any>([])
  const [referalConsultantsOptions, setReferalConsultantsOptions] = useState<any>([])
  const testRef = useRef<any>(null);


  //Signature Section for HomeCare
  const [staffDetails, setStaffDetails] = useState<any>()
  const signaturePanelJSON = {
    "logoPosition": "right",
    "pages": [
      {
        "name": "page1",
        "elements": [
          {
            "type": "signaturepad",
            "penColor": "black",
            "name": "staffSignature",
            "startWithNewLine": false,
            "title": "Signature:",
            "hideNumber": true,
          }
        ]
      }
    ],
    "showCompletedPage": false,
    "showNavigationButtons": "none"
  }
  const [signatureDetails, setSignatureDetails] = useState<any>({
    name: "",
    dateTime: "",
    empCode: "",
    signature: ""
  })
  const [signatureJson, setSignatureJson] = useState<any>(signaturePanelJSON)
  const [signatureData, setSignatureData] = useState<any>({})
  const [selectedInputValue, setSelectedInputValue] = useState<any>({
    prescription: [],
    freq: []
  });
  const [vitalsData, setVitalsData] = useState<any>({})

  useEffect(() => {
    getVitals(recordId)
      .then((data) => {
        setVitalsData(data.data)
      })
      .catch((err) => {
        console.log(err)
        setIsLoading(false)
      })
  }, [])

  const updateSelectedInputValues = (prescriptionPlan: any) => {
    const temp = {
      prescription: [],
      freq: []
    };

    const tempPres: any = prescriptionPlan?.map((prescription: any) => {
      const meds = prescription?.medicines?.map((medicine: any) => medicine?.medicineName);
      return {
        medicines: meds
      };
    });

    temp["prescription"] = tempPres;

    const tempFreq: any = prescriptionPlan?.map((prescription: any) => {
      const freq = prescription?.medicines?.map((medicine: any) => medicine?.frequency);
      return {
        freq: freq
      };
    });

    temp["freq"] = tempFreq;

    setSelectedInputValue(temp);
  };

  useEffect(() => {
    if (scroll) {
      scroll()
    }
  }, [])

  useEffect(() => {
    if (isReadOnly) {
      const tempJson: any = { ...signaturePanelJSON }
      tempJson["pages"][0]["readOnly"] = true
      tempJson["showNavigationButtons"] = "none"
      setSignatureJson(tempJson)
    }
  }, [isReadOnly])

  const followUpOptions = {
    speciality: [
      "Medical Oncologist",
      "Radiation oncologist",
      "Onco-surgeon",
      "Onco-pathologist",
      "Cardiologist",
      "Dentist",
      "Dermatologist",
      "Endocrinologist",
      "Gastroenterologist",
      "Gynecologist",
      "Hematologist",
      "Hepatologist",
      "Immunologist",
      "Nephrologist",
      "Neurologist",
      "Pulmonologist",
      "Ophthalmologist",
      "Orthopedics",
      "Pediatrician",
      "Podiatrist",
      "Urologist",
      "ENT",
      "Rheumatologist",
      "Surgical gastroenterologist",
      "Diabetologist",
      "Physician",
      "Neuro physician",
      "Radiologist",
      "Pathologist",
      "Surgeon",
      "General surgeon",
      "Plastic surgeon",
      "Neurosurgeon",
      "CVT surgeon",
      "Vascular surgeon",
      "Dental surgeon",
      "Retina surgeon",
      "Foot surgeon",
      "Nuclear medicine",
      "Physiotherapist",
      "Psychologist",
      "Psychiatrist",
      "Counselor",
      "Nutritionist",
      "Dietician",
      "Genetic counselor",
      "Geriatric physician",
    ],
  }
  const daysofYear = {
    daysofweek: [
      "Day/Days",
      "Month/Months",
      "Year/Years",
      "Week/Weeks"
    ]
  }
  const monthView: any = daysofYear?.daysofweek.map((ele: any) => {
    return { label: ele, value: ele }
  })

  const specialityName: any = followUpOptions?.speciality.map((ele: any) => {
    return { label: ele, value: ele }
  })
  const [printConsultant, setPrintConsultant] = useState<any>()

  useEffect(() => {
    if (followUpResults) {
      setfollowUpData(followUpResults)
    }
  }, [followUpResults])

  useEffect(() => {
    if (referredToDetails) {
      setReferredTos(referredToDetails)
    }
  }, [referredToDetails])

  useEffect(() => {
    fetchFollowUpDetails()
    if (
      staffType === MocUserRole.HOME_CARE_RMO ||
      staffType === MocUserRole.HOME_CARE_NURSE ||
      userRole === MocUserRole.HOME_CARE_RMO ||
      userRole === MocUserRole.HOME_CARE_NURSE
    ) {
      // setIsLoading(true)
      getSaveNurseNotes(appointmentId)
        .then((res: any) => {
          setIsLoading(false)
          setServicesRendered(res[0]?.servicesRendered?.length > 0 ? res[0]?.servicesRendered : [serviceRendered])
          setServicesRenderedPrint(res[0]?.servicesRendered?.length > 0 ? res[0]?.servicesRendered : [])
        })
        .catch((err: any) => {
          setIsLoading(false)
          console.log(err?.message)
        })
    }

    getServiceBasedOnCategory("HC")
      .then((res: any) => {
        const options = res?.map((ele: any) => {
          return { label: ele?.name, value: ele?.id }
        })
        setTreatmentTypes(options)
      })
      .catch((err: any) => {
        console.log(err?.message)
      })
  }, [appointmentId, recordId, isFetchAgain])

  useEffect(() => {
    if (Object.keys(formFollowUpErrors)?.length === 0 && isFollowUpSubmit) {
      // setIsLoading(true)
      saveFollowUpData()
    }
  }, [formFollowUpErrors, isFollowUpSubmit])

  const getConsultantSignature = async (signatureData: any) => {
    const tempSignData: any = { ...signatureData }

    if (!tempSignData?.name || !tempSignData?.dateTime || !tempSignData?.empCode || !tempSignData?.signature) {
      let tempConsultantId = ""
      if (appointmentType === "IPD") {
        tempConsultantId = patientDetail?.primaryConsultantId
      } else {
        tempConsultantId = consultantId
      }

      let staffResult: any = {}
      if (tempConsultantId) {
        try {
          staffResult = await getManageStaffDetailsById(tempConsultantId)
        }
        catch {
          console.error("Failed to fetch staff details for signature")
        }
      }

      if (Object.keys(staffResult)?.length > 0) {
        if (!tempSignData?.name) {
          tempSignData["name"] = staffResult?.name
        }
        if (!tempSignData?.dateTime) {
          let tempDate = moment(appointmentDate).format("YYYY-MM-DD") + "T" + moment().format("HH:mm")
          tempSignData["dateTime"] = tempDate
        }
        if (!tempSignData?.empCode) {
          tempSignData["empCode"] = staffResult?.mocConsultantId ? staffResult?.mocConsultantId : ""
        }
        if (!tempSignData?.signature) {
          tempSignData["signature"] = staffResult?.signaturePicUrl
          const temp: any = { ...signatureData }
          temp["staffSignature"] = staffResult?.signaturePicUrl
          setSignatureData(temp)
        }
      }
    }

    setSignatureDetails(tempSignData)
  }

  const fetchFollowUpDetails = async () => {
    // setIsLoading(true)
    let staffData: any = []
    let testsData: any = []
    let referalConsultantsData: any = []
    let tempOptions: any = []
    //Tests Options
    try {
      testsData = await getTestsList(centerId)
      tempOptions = testsData?.map((each: any) => {
        return { label: each?.serviceName, value: each?.serviceId }
      })
      setTestsOptions(tempOptions)
    }
    catch {
      console.log("Failed to fetch test")
    }
    //Referal consultants master data
    try {
      referalConsultantsData = await getAllConsultantReferralDetails(userDetail?.currentCenter?.centerId)
      const referalDoctorOptions = referalConsultantsData?.map((ele: any) => {
        return { label: ele?.consultantName, value: ele?.id }
      })
      referalDoctorOptions?.push({ label: "Others", value: "Others" })
      setReferalConsultants(referalConsultantsData)
      setReferalConsultantsOptions(referalDoctorOptions)
    }
    catch {
      console.log("Failed to fetch referral consultant details")
    }
    //Staff details
    try {
      if (userDetail?.id) {
        staffData = await getManageStaffDetailsById(userDetail?.id)
        setStaffDetails(staffData)
      }
    }
    catch {
      console.log("Failed to fetch staff details")
    }
    //Follow up details
    let signatureData: any = {}
    try {
      const followUpData: any = await getFollowUpDetails(recordId, ignoreAutopopulatedFollowUp)
      const { advice, clinicalImpressions, complaints, briefHistory, examination, nextVisit, notes, prescriptionPad, referredTo, testsRequired } = followUpData

      const prescriptionFiltered: any = prescriptionPad?.filter((e: any) => e?.isSaved).map((each: any) => {
        each["addToPrint"] = true
        return each
      });

      const testFiltered: any = testsRequired?.filter((e: any) => e?.isSaved).map((each: any) => {
        each["addToPrint"] = true
        return each
      });

      const formatedPrintFollowUp: any = { advice, clinicalImpressions, briefHistory, complaints, examination, nextVisit, notes, referredTo, prescriptionPad: prescriptionFiltered, testsRequired: testFiltered, signatureDetails: followUpData?.signatureDetails }

      setPrintConsultant(formatedPrintFollowUp)

      if (prescriptionPad?.length > 0 && prescriptionPad !== null) {
        const tempPrescriptions = prescriptionPad?.map((each: any) => {
          const list = each["medicines"]?.map((ele: any) => {
            const t: any = { ...ele }
            if (t?.selectedSideEffects?.length > 0) {
              t.isChosen = true
            } else {
              t.isChosen = false
            }
            return t
          })
          const temp = { ...each }
          temp["medicines"] = list
          temp["addToPrint"] = true
          return temp
        })
        setPrescriptionPlans(tempPrescriptions)
        updateSelectedInputValues(tempPrescriptions)
      } else {
        setPrescriptionPlans([prescriptionItem])
        updateSelectedInputValues([prescriptionItem])

      }
      if (testsRequired?.length > 0 && testsRequired !== null) {
        const tempTests = testsRequired?.map((each: any) => {
          const temp = { ...each }
          temp["addToPrint"] = true
          return temp
        })
        setTestsRequested(tempTests)
      } else {
        setTestsRequested([testRequest])
      }
      if (nextVisit?.split("$")?.length > 1) {
        let nexVisitTemp = nextVisit?.split("$")
        setfollowUpData({
          visitPad: "",
          advice: advice,
          nextVisit: "",
          nextVisit1: nexVisitTemp[0] ? nexVisitTemp[0] : "",
          nextVisit2: nexVisitTemp[1] ? nexVisitTemp[1] : "",
          briefHistory: briefHistory,
          complaints: complaints,
          examination: examination
        })
      } else {
        setfollowUpData({
          visitPad: "",
          advice: advice,
          nextVisit: nextVisit ? nextVisit : "",
          nextVisit1: "",
          nextVisit2: "",
          briefHistory: briefHistory,
          complaints: complaints,
          examination: examination
        })
      }
      if (referredTo) {
        const referredToFormatted: any = referredTo?.map((each: any) => {
          if (each?.doctorName) {
            const isConsulntantOthers = referalConsultantsData?.filter((con: any) => con?.consultantName === each["doctorName"])
            if (isConsulntantOthers?.length <= 0) {
              const temp: any = { ...each }
              temp["doctorNameOthers"] = each?.doctorName
              temp["doctorName"] = "Others"
              return temp
            } else {
              return { ...each }
            }
          } else {
            return { ...each }
          }
        })
        setReferredTos(referredToFormatted)
      }

      if (followUpData?.signatureDetails) {
        signatureData = { ...followUpData?.signatureDetails }
        setSignatureDetails(signatureData)
      }

      setConsultantNotesData({
        clinicalImpression: clinicalImpressions,
        notes: notes,
      })
    }
    catch {
      console.log("Follow up data not found")
    } finally {
      await getConsultantSignature(signatureData)
    }
    setIsLoading(false)
  }


  const saveFollowUpData = async () => {
    let temp
    if (signatureData?.staffSignature) {
      if (!signatureData?.staffSignature?.includes("http")) {
        try {
          const response = await fetch(signatureData?.staffSignature);
          const data = await response.blob()
          const metadata = {
            type: "image/png"
          };
          const file = new File([data], `hc_rmo_signature.png`, metadata);
          const formData = new FormData()
          formData.append('files', file)

          const uploadedFiles = await uploadSpecificFile(formData, true);
          temp = { ...signatureDetails }
          temp["signature"] = uploadedFiles[0]
          setSignatureDetails(temp)
        } catch (err: any) {
          temp = { ...signatureDetails }
          temp["signature"] = ""
          const errCode = err?.response?.data?.code
          if (errCode === 'MaxUploadSizeExceededException') {
            setError(true)
          }
          console.error("Error in uploading file", err)
        }
      } else {
        temp = { ...signatureDetails }
        temp["signature"] = signatureData?.staffSignature
      }
    } else {
      temp = { ...signatureDetails }
      temp["signature"] = ""
    }
    if (staffType !== MocUserRole.HOME_CARE_RMO ||
      staffType !== MocUserRole.HOME_CARE_NURSE ||
      userRole !== MocUserRole.HOME_CARE_RMO ||
      userRole !== MocUserRole.HOME_CARE_NURSE) {
      delete temp["empCode"]
    }
    const referedTosCopy: any = referredTos?.map((each: any) => {
      const eachCopy = { ...each }
      if (Object.keys(eachCopy)?.includes("doctorNameOthers")) {
        if (eachCopy["doctorNameOthers"]) {
          eachCopy["doctorName"] = eachCopy["doctorNameOthers"]
          delete eachCopy["doctorNameOthers"]
        } else {
          delete eachCopy["doctorNameOthers"]
        }
      }
      const keys: any = Object.keys(eachCopy)
      if (keys?.length > 0) {
        keys?.forEach((eachKey: any) => {
          if (!eachCopy[eachKey]) {
            delete eachCopy[eachKey]
          }
        })
      }
      return eachCopy
    })
    const tempReferedTos: any = referedTosCopy?.filter((ele: any) => Object.keys(ele)?.length > 0)
    const updatedReferedTos: any = tempReferedTos?.length > 0 ? tempReferedTos : null
    addFollowUP(
      { ...followUpData, ...consultantNotesData, prescriptionPlans, testsRequested, updatedReferedTos, temp },
      {
        centerId,
        consultantId,
        patientId,
        appointmentId,
        recordId,
      }
    )
      .then((data) => {
        setIsLoading(false)
        setResFollowUpData(data)
        if (
          staffType === MocUserRole.HOME_CARE_RMO ||
          staffType === MocUserRole.HOME_CARE_NURSE ||
          userRole === MocUserRole.HOME_CARE_RMO ||
          userRole === MocUserRole.HOME_CARE_NURSE
        ) {
          // setIsLoading(true)
          const temp = servicesRendered?.every((e: any) => e?.serviceTemplateId === "")
          const servicesRenderedPayload = {
            "servicesRendered": temp ? [] : servicesRendered,
            "status": "SAVED"
          }
          if (!temp) {
            saveNurseNotes(servicesRenderedPayload, appointmentId)
              .then((res: any) => {
                setIsFetchAgain(!isFetchAgain)
                setIsLoading(false)
                setIsFollowUpData(true)
              })
              .catch((error: any) => {
                setIsLoading(false)
                setMessage(error?.response?.data?.message)
                setError(true)
              })
          } else {
            setIsFetchAgain(!isFetchAgain)
            setIsFollowUpData(true)
            setIsLoading(false)
          }
        } else {
          setIsFollowUpData(true)
          setIsFetchAgain(!isFetchAgain)
          setIsLoading(false)
        }
      })
      .catch((err: any) => {
        console.log(err?.message)
        setIsLoading(false)
        setError(true)
      })
  }

  const uploadFile = async (key: string, url: string): Promise<string> => {
    return new Promise<string>(async (resolve, reject) => {
      if (!url?.includes("http")) {
        try {
          const response = await fetch(url)
          const data = await response.blob()
          const metadata = {
            type: "image/png"
          }
          const file = new File([data], `${key}.png`, metadata)
          const formData = new FormData()
          formData.append('files', file)
          const uploadedFiles = await uploadSpecificFile(formData, true)
          resolve(uploadedFiles[0])
        } catch (err: any) {
          console.error("Error in uploading file", err)
          if (err.response?.data?.code === 'MaxUploadSizeExceededException') {
            setError(true)
          }
          reject(err)
        }
      }
      else {
        return url;
      }
    })
  }

  const checkDrugInteraction = (values: any) => {
    checkIcdDrugInteraction(values)
      .then((res: any) => {
        let msg = ''
        if (res?.fullInteractionTypeGroup) {
          res?.fullInteractionTypeGroup[0]?.fullInteractionType.forEach((each: any) => msg += each?.comment)
          const temp = msg?.split("asserted in DrugBank between")
          let displayText = ""
          for (let i = 1; i < temp.length; i += 2) {
            const parts = temp[i]?.split(".")
            displayText += `> Interaction found between${parts[0]}.\n`
          }
          if (displayText) {
            setMessage(displayText)
            setOpen(true)
          }
        }
      })
      .catch((err: any) => {
        console.log(err?.message)
      })
  }

  const handleFollowUpSubmit = (e: any) => {
    e.preventDefault()
    e.stopPropagation()
    if (scroll) {
      scroll()
    }
    setFormFollowUpErrors(validateFollowUp(followUpData))

    setIsFollowUpSubmit(true)
  }

  const validateFollowUp = (values: any) => {
    const errors: any = {}
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i
    return errors
  }

  function onReferredToValueChange(source: any, value: any, index: any) {
    const values = [...referredTos]
    values[index][source] = value
    setReferredTos([...values])
  }

  const onSaveOrUpdate = (e: any, outerIndex: any) => {
    // setIsLoading(true)
    e.preventDefault()
    e.stopPropagation()

    const t = { ...testsRequested[outerIndex] }
    t["isSaved"] = true
    delete t["addToPrint"]

    if (e?.target?.innerHTML === "Save") {
      const count = testsRequested?.length
      console.log("count test required", count)
      saveTest(recordId, t, count)
        .then((res: any) => {
          setIsLoading(false)
          const prescriptionFiltered: any = res?.prescriptionPad?.filter((e: any) => e?.isSaved).map((each: any) => {
            each["addToPrint"] = true
            return each
          });;

          const testFiltered: any = res?.testsRequired?.filter((e: any) => e?.isSaved).map((each: any) => {
            each["addToPrint"] = true
            return each
          });

          const formatedPrintFollowUp: any = { ...res, prescriptionPad: prescriptionFiltered, testsRequired: testFiltered }

          setPrintConsultant(formatedPrintFollowUp)

          updateTests(res)
          setOpen(true)
          setMessage("Saved Successfully")
        })
        .catch((err: any) => {
          console.log(err?.message)
          setIsLoading(false)
          setError(true)
        })
    } else {
      updateTest(recordId, t)
        .then((res: any) => {
          setIsLoading(false)
          const prescriptionFiltered: any = res?.prescriptionPad?.filter((e: any) => e?.isSaved).map((each: any) => {
            each["addToPrint"] = true
            return each
          });;

          const testFiltered: any = res?.testsRequired?.filter((e: any) => e?.isSaved).map((each: any) => {
            each["addToPrint"] = true
            return each
          });

          const formatedPrintFollowUp: any = { ...res, prescriptionPad: prescriptionFiltered, testsRequired: testFiltered }

          setPrintConsultant(formatedPrintFollowUp)

          updateTests(res)
          setOpen(true)
          setMessage("Updated Successfully")
        })
        .catch((err: any) => {
          console.log(err?.message)
          setIsLoading(false)
          setError(true)
        })
    }
  }

  const onSend = (e: any, outerIndex: any) => {
    // setIsLoading(true)
    e.preventDefault()
    e.stopPropagation()

    const t = { ...testsRequested[outerIndex] }
    t["isSent"] = true

    sendTest(recordId, t)
      .then((res: any) => {
        setIsLoading(false)
        updateTests(res)

        const prescriptionFiltered: any = res?.prescriptionPad?.filter((e: any) => e?.isSaved).map((each: any) => {
          each["addToPrint"] = true
          return each
        });;

        const testFiltered: any = res?.testsRequired?.filter((e: any) => e?.isSaved).map((each: any) => {
          each["addToPrint"] = true
          return each
        });

        const formatedPrintFollowUp: any = { ...res, prescriptionPad: prescriptionFiltered, testsRequired: testFiltered }

        setPrintConsultant(formatedPrintFollowUp)

        setOpen(true)
        setMessage("Sent Successfully")
      })
      .catch((err: any) => {
        console.log(err?.message)
        setIsLoading(false)
        setMessage(err?.response?.data?.message)
        setError(true)
      })
  }

  const onCancel = (e: any, outerIndex: any) => {
    // setIsLoading(true)
    e.preventDefault()
    e.stopPropagation()

    const t = { ...testsRequested[outerIndex] }
    t["isCancelled"] = true

    cancelTest(recordId, t)
      .then((res: any) => {
        setIsLoading(false)
        updateTests(res)

        const prescriptionFiltered: any = res?.prescriptionPad?.filter((e: any) => e?.isSaved).map((each: any) => {
          each["addToPrint"] = true
          return each
        });;

        const testFiltered: any = res?.testsRequired?.filter((e: any) => e?.isSaved).map((each: any) => {
          each["addToPrint"] = true
          return each
        });

        const formatedPrintFollowUp: any = { ...res, prescriptionPad: prescriptionFiltered, testsRequired: testFiltered }

        setPrintConsultant(formatedPrintFollowUp)

        setOpen(true)
        setMessage("Cancelled Successfully")
      })
      .catch((err: any) => {
        console.log(err?.message)
        setIsLoading(false)
        setError(true)
      })
  }

  const updateTests = (data: any) => {
    const { testsRequired } = data
    setTestsRequested(testsRequired)
  }

  const updateSurveyData = (data: any, survey: any) => {
    setSignatureData(data)
  }

  const customStyles = {
    control: (provided: any) => ({
      ...provided,
      border: "1px solid #ccd0e7",
      borderRadius: "10px",
      fontWeight: 700
    }),
    option: (provided: any) => ({
      ...provided,
      fontWeight: 700
    })
  };

  return (
    <>
      <div className="prescription-plan mt-4">
        {
          open ? (
            <Toast
              textMessage={message}
              onCloseText={"Close"}
              onClose={() => {
                setOpen(false)
                setMessage("")
              }}
              type="success"
            ></Toast>
          ) : error ? (
            <Toast
              textMessage={message ? message : "Something went wrong, Please try again later."}
              onCloseText={"Close"}
              onClose={() => {
                setError(false)
                setMessage("")
              }}
              type="error"
            ></Toast>
          ) : isLoading ? (
            <div
              style={{
                position: "absolute",
                top: "50%",
                right: "50%",
              }}
            >
              <div
                style={{ width: "3rem", height: "3rem" }}
                className="spinner-border text-primary"
              ></div>
            </div>
          ) : ""
        }
        <div className="print-btn">
          <Print componentRef={followUpPrintRef} />
        </div>
        <div className="follow-up-wrapper">
          <div className="heading">Brief History</div>
          <div className="textarea">
            <textarea
              name=""
              id=""
              cols={50}
              rows={5}
              value={followUpData?.briefHistory}
              onChange={(e) =>
                setfollowUpData({ ...followUpData, briefHistory: e.target.value })
              }
              disabled={!isEditable || isReadOnly}
              className={`${!isEditable ? "editable" : ""} col-md-12`}
            />
          </div>
          <div className="heading">Complaints</div>
          <div className="textarea">
            <textarea
              name=""
              id=""
              cols={50}
              rows={5}
              value={followUpData?.complaints}
              onChange={(e) =>
                setfollowUpData({ ...followUpData, complaints: e.target.value })
              }
              disabled={!isEditable || isReadOnly}
              className={`${!isEditable ? "editable" : ""} col-md-12`}
            />
          </div>
          <div className="heading">Examination</div>
          <div className="textarea">
            <textarea
              name=""
              id=""
              cols={50}
              rows={5}
              value={followUpData?.examination}
              onChange={(e) =>
                setfollowUpData({
                  ...followUpData,
                  examination: e.target.value,
                })
              }
              disabled={!isEditable || isReadOnly}
              className={`${!isEditable ? "editable" : ""} col-md-12`}
            />
          </div>
          <div className="clinical-impression ">
            <div className="heading">Clinical Impressions</div>
            <div>
              <textarea
                name=""
                id=""
                cols={50}
                rows={5}
                value={consultantNotesData?.clinicalImpression}
                onChange={(e) =>
                  setConsultantNotesData({
                    ...consultantNotesData,
                    clinicalImpression: e.target.value,
                  })
                }
                disabled={!isEditable || isReadOnly}
                className={`${!isEditable ? "editable" : ""} col-md-12`}
              />
            </div>
          </div >
          <div className="notes mt-4">
            <div className="heading">Notes</div>
            <div>
              <textarea
                value={consultantNotesData?.notes}
                onChange={(e) =>
                  setConsultantNotesData({
                    ...consultantNotesData,
                    notes: e.target.value,
                  })
                }
                disabled={!isEditable || isReadOnly}
                className={`${!isEditable ? "editable" : ""} col-md-12`}
              />
            </div>
          </div>
          <div className="template-row-og mt-4">
            <div className='style-column-con'>
              <label style={{ marginBottom: "10px", fontWeight: "600" }}>Load Previous Take Home Medicine</label>
              <Select
                defaultValue={{
                  label: "",
                  value: ""
                }}
                styles={customStyles}
                value={{
                  label: selectedOptionLoadChemo?.label,
                  value: selectedOptionLoadChemo?.value
                }}
                options={dropdownCancerOrder}
                onChange={(evnt: any) => {
                  const templateName = evnt?.value
                  setSelectedOptionLoadChemo(evnt)
                  getSelectedChemoOrder(templateName)
                    .then((res: any) => {
                      // setInitialValue({ ...initialValue, chemoTemplate: res?.templateName })
                      // setInitialValue({
                      //   ...initialValue, regimen: '',
                      //   chemoTemplate: res?.templateName
                      // })

                      const newTakeHome = res?.takeHomeMedicines ? res?.takeHomeMedicines : null;
                      // const tempTakeHome: any = [...newTakeHome]
                      // const tempFormattedTakeHome: any = tempTakeHome?.map((each: any) => {
                      //   if (!(each?.addToPrint === false)) {
                      //     return { ...each, addToPrint: true }
                      //   }
                      // })
                      if (res?.testsToBeDone) {
                        const formattedTestsToBeDone = res?.testsToBeDone.map((item: any) => {
                          const { id, integrationOrderId, ...rest } = item;
                          return {
                            ...rest,
                            tests: rest.tests.map((each: any) => ({
                              ...each,
                              when: each.when !== "" ? "" : each.when
                            }))
                          };
                        });
                        setTestsRequested(formattedTestsToBeDone);
                        // setTestsRequested(res?.testsToBeDone)
                      }
                      const temp = [prescriptionItem]

                      temp[0]["medicines"] = newTakeHome ? newTakeHome[0]?.medicines : prescriptionItem.medicines

                      const tempPrescriptions = temp?.map((each: any) => {
                        const list = each["medicines"]?.map((ele: any) => {
                          const t: any = { ...ele }
                          if (t?.selectedSideEffects?.length > 0) {
                            t.isChosen = true
                          } else {
                            t.isChosen = false
                          }
                          return t
                        })
                        const temp1 = { ...each }
                        temp1["medicines"] = list
                        return temp1
                      })
                      setPrescriptionPlans(tempPrescriptions)
                      updateSelectedInputValues(tempPrescriptions)
                    })
                    .catch((error: any) => {
                      console.log(error)
                    })
                }}
                isDisabled={isReadOnly}
              />
            </div>
          </div>
          {
            prescriptionPlans?.map((each: any, outerIndex: any) => {
              const freezePrescription = each["isCancelled"]
              return (
                <TreatmentPlan
                  isEditable={isEditable}
                  prescriptionPlanItem={each}
                  prescriptionItem={prescriptionItem}
                  prescriptionPlans={prescriptionPlans}
                  printConsultant={printConsultant}
                  setPrintConsultant={setPrintConsultant}
                  outerIndex={outerIndex}
                  freezePrescription={freezePrescription}
                  setPrescriptionPlans={setPrescriptionPlans}
                  checkDrugInteraction={checkDrugInteraction}
                  isReadOnly={isReadOnly}
                  recordId={recordId}
                  setIsLoading={setIsLoading}
                  selectedInputValue={selectedInputValue}
                  setSelectedInputValue={setSelectedInputValue}
                  updateSelectedInputValues={updateSelectedInputValues}
                />
              )
            })
          }

          {
            prescriptionPlans[prescriptionPlans?.length - 1]["readyToSent"] ? (
              (isEditable && !isReadOnly) && (
                <div className="comorbidities add-new-item">
                  <div
                    className={`add-new-button`}
                    onClick={() => {
                      const temp: any = [...prescriptionPlans]
                      temp.push(prescriptionItem)
                      setPrescriptionPlans(temp)
                      updateSelectedInputValues(temp)
                    }}
                  >
                    Add New Prescription
                  </div>
                </div>
              )
            ) : (
              (isEditable && !isReadOnly) && (
                <div className="comorbidities add-new-item">
                  <div
                    className={`add-new-button test-none`}
                  >
                    Add New Prescription
                  </div>
                </div>
              )
            )
          }

          {/* Tests Required Panel*/}
          {
            testsRequested?.map((each: any, outerIndex: any) => {
              const freezeLabPrescription = each["isCancelled"]
              return (
                <div className="test-required mt-4">
                  <div className="heading">
                    <div className="heading-left">
                      <span>Tests Required</span>
                    </div>
                    {each?.isSaved && <div className="heading-right">
                      <span>
                        Add to print
                      </span>
                      <input
                        type="checkbox"
                        className="add-to-print-checkbox"
                        checked={each?.addToPrint}
                        onChange={(e: any) => {
                          const temp: any = [...testsRequested]
                          temp[outerIndex]["addToPrint"] = e?.target?.checked
                          const tempPrintConsultant: any = { ...printConsultant }
                          tempPrintConsultant.testsRequired = temp.filter((e: any) => e?.isSaved)
                          setPrintConsultant(tempPrintConsultant)
                          setTestsRequested(temp)
                        }}
                        disabled={isReadOnly}
                      />
                    </div>}
                  </div>
                  <div className="custom-table">
                    <table>
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Test Name</th>
                          <th>Instructions</th>
                          <th>Test(when)</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        {each?.tests?.map((eachTest: any, index: any) => {
                          return (
                            <tr>
                              <td style={{
                                margin: 0, paddingTop: "5px", paddingLeft: "8px",
                                borderColor: "hsl(0, 0%, 80%)",
                                borderWidth: "1px",
                                borderRadius: "4px",
                                borderStyle: "solid",
                                boxSizing: "border-box"
                              }}>{index + 1}</td>
                              <td className="test-td-table padding-style" style={{ margin: 0, padding: 0 }} >
                                <Select
                                  options={testsOptions}
                                  defaultValue={eachTest?.serviceId}
                                  onChange={(option: any) => {
                                    const values = { ...each }
                                    values["tests"][index]["serviceId"] = option?.value
                                    values["tests"][index]["testName"] = option?.label
                                    const t = [...testsRequested]
                                    t[outerIndex] = values
                                    setTestsRequested(t)
                                  }}
                                  isDisabled={!isEditable || isReadOnly || freezeLabPrescription}
                                  value={testsOptions.filter(({ value }: any) => value === Number(eachTest?.serviceId))}
                                />
                              </td>
                              <td className="test-td-table testing-border" style={{ margin: 0, padding: 0 }}>
                                <InputField
                                  className="instruction-tests-fol"
                                  handleChange={(e) => {
                                    const values = { ...each }
                                    values["tests"][index]["instructions"] = e?.target?.value
                                    // setTestsRequestedItem(values)
                                    const t = [...testsRequested]
                                    t[outerIndex] = values
                                    setTestsRequested(t)
                                  }}
                                  value={eachTest?.instructions}
                                  readOnly={!isEditable || isReadOnly || freezeLabPrescription}
                                />
                              </td>
                              <td className="test-td-table testing-border" style={{ margin: 0, padding: 0 }}>
                                <InputField
                                  className="instruction-tests-fol"
                                  calendar={true}
                                  handleChange={(e) => {
                                    const values = { ...each }
                                    values["tests"][index]["when"] = e?.target?.value
                                    // setTestsRequestedItem(values)
                                    const t = [...testsRequested]
                                    t[outerIndex] = values
                                    setTestsRequested(t)
                                  }}
                                  value={eachTest?.when}
                                  readOnly={!isEditable || isReadOnly || freezeLabPrescription}
                                />
                              </td>
                              {testsRequested[outerIndex]?.tests?.length > 1 ? (isEditable && !isReadOnly && !freezeLabPrescription) && (
                                <td>
                                  <div
                                    className="delete-icon"
                                    onClick={() => {
                                      if (testsRequested[outerIndex]?.tests?.length > 1) {
                                        const values = { ...each }
                                        values?.tests?.splice(index, 1)
                                        // setTestsRequestedItem(values)
                                        const t = [...testsRequested]
                                        t[outerIndex] = values
                                        setTestsRequested(t)
                                      } else {
                                        const values: any = { ...each }
                                        values.tests = [testRequest]
                                        const t = [...testsRequested]
                                        t[outerIndex] = values
                                        setTestsRequested(t)
                                      }
                                    }}
                                  >
                                    <img
                                      src="../../assets/images/delete-icon.svg"
                                      alt="delete"
                                    />
                                  </div>
                                </td>
                              ) :
                                (isEditable && !isReadOnly && !freezeLabPrescription) && (
                                  <td>
                                    <div
                                      className="delete-icon"
                                      style={{ cursor: "not-allowed" }}
                                    >
                                      <img
                                        src="../../assets/images/delete-icon.svg"
                                        alt="delete"
                                      />
                                    </div>
                                  </td>
                                )}
                            </tr>
                          )
                        })}
                      </tbody>
                    </table>
                    {(isEditable && !isReadOnly && !freezeLabPrescription) && (
                      <div className="comorbidities add-new mr-2">
                        <div
                          className="add-new-button"
                          onClick={() => {
                            const values: any = { ...each }
                            values?.tests?.push(testItem)
                            // setTestsRequestedItem(values)
                            const t = [...testsRequested]
                            t[outerIndex] = values
                            setTestsRequested(t)
                          }}
                        >
                          Add New
                        </div>
                      </div>
                    )}
                  </div>
                  <div className="prescription-actions">
                    <div className="save-button mt-4">
                      {
                        isReadOnly ?
                          ""
                          :
                          <Button
                            text={!each?.isSaved ? "Save" : each?.id && each?.integrationOrderId ? "Update" : "Save"}
                            id="save"
                            onClick={(e: any) => {
                              onSaveOrUpdate(e, outerIndex)
                            }}
                            disabled={each?.isCancelled || each?.isSent ? true : false}
                          ></Button>
                      }
                    </div>
                    <div className="save-button mt-4">
                      {
                        isReadOnly ?
                          ""
                          :
                          <Button
                            text="Send"
                            id="send"
                            onClick={(e: any) => {
                              onSend(e, outerIndex)
                            }}
                            disabled={each?.isSent ? true : false || !each?.id}
                          ></Button>
                      }
                    </div>
                    <div className="save-button mt-4">
                      {
                        isReadOnly ?
                          ""
                          :
                          <Button
                            text="Cancel"
                            id="cancel"
                            onClick={(e: any) => {
                              onCancel(e, outerIndex)
                            }}
                            disabled={!each?.isSent || each?.isCancelled ? true : false}
                          ></Button>
                      }
                    </div>
                  </div>
                </div>
              )
            })
          }

          {testsRequested[testsRequested?.length - 1]["isSent"] ? (
            (isEditable && !isReadOnly) && (
              <div className="comorbidities add-new-item">
                <div
                  className={`add-new-button`}
                  onClick={() => {
                    const temp: any = [...testsRequested]
                    temp.push(testRequest)
                    setTestsRequested(temp)
                  }}
                >
                  Add New Test
                </div>
              </div>
            )
          ) : (
            (isEditable && !isReadOnly) && (
              <div className="comorbidities add-new-item">
                <div
                  className={`add-new-button test-none`}
                >
                  Add New Test
                </div>
              </div>
            )
          )}

          {(
            staffType === MocUserRole.HOME_CARE_RMO ||
            staffType === MocUserRole.HOME_CARE_NURSE ||
            userRole === MocUserRole.HOME_CARE_RMO ||
            userRole === MocUserRole.HOME_CARE_NURSE
          ) && (
              <div className="test-required mt-4">
                <div className="heading">Services Rendered</div>
                <div className="custom-table">
                  <table>
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Type</th>
                        <th>Completed By</th>
                      </tr>
                    </thead>
                    <tbody>
                      {servicesRendered?.map((service, index) => {
                        return (
                          <tr>
                            <td>{index + 1}</td>
                            <td>
                              <Select
                                styles={{
                                  control: (provided, state) => ({
                                    ...provided,
                                    border: "1px solid #ccd0e7",
                                    borderRadius: "10px"
                                  })
                                }}
                                options={treatmentTypes}
                                defaultValue={service?.serviceTemplateName}
                                onChange={(option: any) => {
                                  const values = [...servicesRendered]
                                  values[index].serviceTemplateName = option?.label
                                  values[index].serviceTemplateId = option?.value
                                  setServicesRendered([...values])
                                }}
                                value={treatmentTypes.filter(({ label }: any) => label === service?.serviceTemplateName)}
                                isDisabled={!isEditable || isReadOnly}
                              />
                            </td>
                            <td>
                              <InputField
                                // className="border-add"
                                handleChange={(e) => {
                                  const values = [...servicesRendered]
                                  values[index].completedBy = e.target.value
                                  setServicesRendered([...values])
                                }}
                                value={service?.completedBy}
                                readOnly={!isEditable || isReadOnly}
                              />
                            </td>
                            <td>
                              {servicesRendered.length > 1 ? (
                                !isReadOnly ?
                                  <div
                                    className="delete-icon"
                                    onClick={() => {
                                      if (servicesRendered.length > 1) {
                                        const values = [...servicesRendered]
                                        values.splice(index, 1)
                                        setServicesRendered(values)
                                      }
                                    }}
                                  >
                                    <img
                                      src="../../assets/images/delete-icon.svg"
                                      alt="delete"
                                    />
                                  </div> : "") : (
                                !isReadOnly ?
                                  <div
                                    className="delete-icon"
                                    style={{ cursor: "not-allowed" }}
                                  >
                                    <img
                                      src="../../assets/images/delete-icon.svg"
                                      alt="delete"
                                    />
                                  </div> : ""
                              )
                              }
                            </td>
                          </tr>
                        )
                      })}
                    </tbody>
                  </table>
                  <div className="comorbidities add-new mr-2">
                    {
                      !isReadOnly ? (
                        <div
                          className="add-new-button"
                          onClick={() =>
                            setServicesRendered([
                              ...servicesRendered,
                              serviceRendered,
                            ])
                          }
                        >
                          Add New
                        </div>
                      ) : null
                    }
                  </div>
                </div>
              </div>
            )}
          <div className="advice mt-4">
            <div className="heading">Advice</div>
            <textarea
              value={followUpData?.advice}
              onChange={(e) =>
                setfollowUpData({ ...followUpData, advice: e.target.value })
              }
              disabled={!isEditable || isReadOnly}
              className={`${!isEditable ? "editable" : ""} col-md-12`}
            />
            {/* <InputField
            value={followUpData?.advice}
            handleChange={(e) =>
              setfollowUpData({ ...followUpData, advice: e.target.value })
            }
            readOnly={!isEditable || isReadOnly}
          /> */}
          </div>
          <div className="next-visit mt-4">
            <div className="heading">Next Visit</div>
            <div className="next">
              <div className="col-md-3 col-lg-4">
                <InputField
                  // className="border-add"
                  calendar={true}
                  value={followUpData?.nextVisit}
                  handleChange={(e) =>
                    setfollowUpData({
                      ...followUpData,
                      nextVisit: e.target.value,
                      nextVisit1: "",
                      nextVisit2: "",
                    })
                  }
                  readOnly={followUpData.nextVisit1 !== "" ? true : false || isReadOnly} />
              </div>
              <div className="col-md-1 text-center">
                <div className="or">OR</div>
              </div>
              <div className="col-md-3">
                <InputField
                  // className="border-add"
                  placeholder="Number"
                  value={followUpData.nextVisit1}
                  handleChange={(e) => {
                    const value = e.target.value
                    let res = ""
                    value?.split("").forEach((ele) => {
                      let k = ele.charCodeAt(0)
                      if (k >= 48 && k <= 57) {
                        res += ele
                      }
                    })
                    setfollowUpData({
                      ...followUpData,
                      nextVisit1: res,
                      nextVisit: "",
                    })
                  }}
                  readOnly={followUpData.nextVisit !== "" ? true : false ||
                    isReadOnly
                  } />
              </div>
              <div className="pt-1 col-md-3">
                {/* <Dropdown
                  options={["Day", "Week", "Month", "Year"]}
                  selected={followUpData.nextVisit2}
                  width={"250px"}
                  placeholder="Select Duration"
                  updateDropdown={(options: any) =>
                    setfollowUpData({
                      ...followUpData,
                      nextVisit: "",
                      nextVisit2: options,
                    })
                  }
                  disable={!isEditable || isReadOnly}
                /> */}
                <Select
                  styles={{
                    control: (provided, state) => ({
                      ...provided,
                      border: "1px solid #ccd0e7",
                      borderRadius: "10px"
                    })
                  }}
                  options={monthView}
                  defaultValue={followUpData.nextVisit2}
                  onChange={(option: any) => {
                    setfollowUpData({
                      ...followUpData,
                      nextVisit: "",
                      nextVisit2: option?.value,
                    })
                  }}
                  value={monthView.filter(({ label }: any) => label === followUpData.nextVisit2)}
                  isDisabled={followUpData.nextVisit !== "" ? true : false ||
                    isReadOnly} />
              </div>
            </div>
          </div>
          <div className="referred-to mt-4">
            <div className="heading">Referred to:</div>
            {referredTos?.map((referedTo: any, index: any) => {
              return (
                <>
                  <div className="referred-to-field mb-2">
                    <div className="col-md-3 col-lg-3">
                      <label htmlFor="">Consultant Name</label>
                      <Select
                        styles={{
                          control: (provided, state) => ({
                            ...provided,
                            border: "1px solid #ccd0e7",
                            borderRadius: "10px"
                          })
                        }}
                        className="country-select"
                        options={referalConsultantsOptions}
                        onChange={(option: any) => {
                          if (option?.label === "Others") {
                            const referredToFormatted: any = referredTos?.map((ele: any, i: any) => {
                              if (i === index) {
                                return {
                                  ...ele, ...{ doctorName: option?.label, speciality: "", phoneNo: "", emailId: "", doctorNameOthers: "" }
                                }
                              } else {
                                return { ...ele }
                              }
                            })
                            setReferredTos(referredToFormatted)
                          } else {
                            const referredToFormatted: any = referredTos?.map((ele: any, i: any) => {
                              if (i === index) {
                                const foundObj: any = referalConsultants?.find((e: any) => e?.id === option?.value)
                                const temp: any = {
                                  ...ele, ...{
                                    doctorName: option?.label,
                                    speciality: foundObj?.specialization ? foundObj?.specialization : "",
                                    phoneNo: foundObj?.phoneNumber ? foundObj?.phoneNumber : "",
                                    emailId: foundObj?.emailId ? foundObj?.emailId : ""
                                  }
                                }
                                delete temp["doctorNameOthers"]
                                return temp
                              } else {
                                return { ...ele }
                              }
                            })
                            setReferredTos(referredToFormatted)
                          }
                        }}
                        placeholder="Consultant Name"
                        value={referalConsultantsOptions.filter(
                          ({ label }: any) =>
                            label === referedTo?.doctorName
                        )}
                        isDisabled={!isEditable || isReadOnly}
                      />
                    </div>
                    <div className="col-md-3 col-lg-3">
                      <label htmlFor="">Speciality</label>
                      {/* <Select
                            options={specialityName}
                            defaultValue={referredTos[index].speciality}
                            onChange={(option: any) => {
                              const values = [...referredTos]
                              values[index].speciality = option?.value
                              setReferredTos([...values])
                            }}
                            value={specialityName.filter(({ label }: any) => label === referredTos[index].speciality)}
                            isDisabled={(referredTos[index].doctorName === "" ? true : false) || isReadOnly}
                          /> */}
                      <InputField
                        // className="border-add"
                        placeholder="Speciality"
                        handleChange={(e) =>
                          onReferredToValueChange(
                            "speciality",
                            e.target.value,
                            index
                          )
                        }
                        value={referedTo?.speciality}
                        readOnly={(referredTos[index].doctorName === "" ? true : false) || isReadOnly}
                      />
                    </div>
                    <div className="col-md-2 col-lg-2">
                      <label htmlFor="">Phone No.</label>
                      <InputField
                        // className="border-add"
                        placeholder="Phone No"
                        handleChange={(e) => {
                          const value = e.target.value
                          let res = ""
                          value?.split("")?.forEach((ele: any) => {
                            let k = ele?.charCodeAt(0)
                            if (k >= 48 && k <= 57) {
                              res += ele
                            }
                          })
                          if (res?.length <= 10) {
                            onReferredToValueChange("phoneNo", res, index)
                          }
                        }}
                        value={referedTo?.phoneNo}
                        readOnly={!isEditable || referedTo?.doctorName === "" || isReadOnly}
                      />
                    </div>
                    <div className="col-md-2 col-lg-2">
                      <label htmlFor="">Email ID</label>
                      <InputField
                        // className="border-add"
                        placeholder="Email ID"
                        handleChange={(e) =>
                          onReferredToValueChange("emailId", e.target.value, index)
                        }
                        value={referedTo?.emailId}
                        readOnly={!isEditable || referedTo?.doctorName === "" || isReadOnly}
                      />
                    </div>
                    {referredTos.length > 1 ? (isEditable || !isReadOnly && (
                      <div
                        className="delete-icon"
                        onClick={() => {
                          if (referredTos.length > 1) {
                            const values = [...referredTos]
                            values.splice(index, 1)
                            setReferredTos(values)
                          }
                        }}
                      >
                        <img src="../../assets/images/delete-icon.svg" alt="" />
                      </div>
                    )) : (isEditable || !isReadOnly && (
                      <div
                        className="delete-icon"
                        style={{ cursor: "not-allowed" }}
                      >
                        <img src="../../assets/images/delete-icon.svg" alt="" />
                      </div>
                    ))}
                  </div>
                  {
                    referedTo?.doctorName === "Others" && (
                      <div className="referred-to-field mb-2">
                        <div className="col-md-3 col-lg-3">
                          <InputField
                            // className="border-add"
                            placeholder="Name"
                            handleChange={(e) =>
                              onReferredToValueChange(
                                "doctorNameOthers",
                                e.target.value,
                                index
                              )
                            }
                            value={referedTo?.doctorNameOthers}
                            readOnly={(referredTos[index].doctorName === "" ? true : false) || isReadOnly}
                          />
                        </div>
                      </div>
                    )
                  }
                </>
              )
            })}
            {isEditable || !isReadOnly && (
              <div className="comorbidities add-new">
                <div
                  className="add-new-button"
                  onClick={() => setReferredTos([...referredTos, referredTo])}
                >
                  Add New
                </div>
              </div>
            )}
          </div>
          {/* Section for Homecare */}
          {
            (
              staffType === MocUserRole.HOME_CARE_RMO ||
              staffType === MocUserRole.HOME_CARE_NURSE ||
              userRole === MocUserRole.HOME_CARE_RMO ||
              userRole === MocUserRole.HOME_CARE_NURSE
            ) ? (
              <>
                <div className="heading mt-4">Signature Details:</div>
                <div className="referred-to-field mb-2">
                  <div className="col-md-3 col-lg-3">
                    <label>Name</label>
                    <InputField
                      // className="border-add"
                      placeholder="Name"
                      handleChange={(e: any) => {
                        setSignatureDetails({ ...signatureDetails, name: e?.target?.value })
                      }}
                      value={signatureDetails?.name}
                      readOnly={isReadOnly}
                    />
                  </div>
                  <div className="col-md-3 col-lg-3">
                    <label>Date/Time</label>
                    <InputField
                      // className="border-add"
                      type="datetime-local"
                      placeholder="Date/Time"
                      handleChange={(e) => {
                        setSignatureDetails({ ...signatureDetails, dateTime: e?.target?.value })
                      }}
                      value={signatureDetails?.dateTime}
                      readOnly={isReadOnly}
                    />
                  </div>
                  <div className="col-md-3 col-lg-3">
                    <label htmlFor="">Emp Code</label>
                    <InputField
                      // className="border-add"
                      placeholder="Emp Code"
                      handleChange={(e) => {
                        setSignatureDetails({ ...signatureDetails, empCode: e?.target?.value })
                      }}
                      value={signatureDetails?.empCode}
                      readOnly={isReadOnly}
                    />
                  </div>
                </div>
                <div className="referred-to-field mb-2">
                  <div className="col-md-4 col-lg-4">
                    <SurveyComponent
                      css={{}}
                      data={signatureData}
                      json={signatureJson}
                      onComplete={(survey: any) => {
                        /** Save to a database */
                        /** Add to a spreadsheet, etc.... */
                      }}
                      updateFlag={updateSurveyData}
                      hideDot={true}
                    />
                  </div>
                </div>
              </>
            ) : null
          }
          {/* Section for RMO / Consultant */}
          {
            (
              staffType !== MocUserRole.HOME_CARE_RMO &&
              staffType !== MocUserRole.HOME_CARE_NURSE &&
              userRole !== MocUserRole.HOME_CARE_RMO &&
              userRole !== MocUserRole.HOME_CARE_NURSE
            ) ? (
              <>
                <div className="heading mt-4">Signature Details:</div>
                <div className="referred-to-field mb-2">
                  <div className="col-md-3 col-lg-3">
                    <label>Name</label>
                    <InputField
                      // className="border-add"
                      placeholder="Name"
                      handleChange={(e: any) => {
                        setSignatureDetails({ ...signatureDetails, name: e?.target?.value })
                      }}
                      value={signatureDetails?.name}
                      readOnly={isReadOnly}
                    />
                  </div>
                  <div className="col-md-3 col-lg-3">
                    <label>Date/Time</label>
                    <InputField
                      // className="border-add"
                      type="datetime-local"
                      placeholder="Date/Time"
                      handleChange={(e) => {
                        setSignatureDetails({ ...signatureDetails, dateTime: e?.target?.value })
                      }}
                      value={signatureDetails?.dateTime}
                      readOnly={isReadOnly}
                    />
                  </div>
                </div>
                <div className="referred-to-field mb-2">
                  <div className="col-md-4 col-lg-4">
                    <SurveyComponent
                      css={{}}
                      data={signatureData}
                      json={signatureJson}
                      onComplete={(survey: any) => {
                        /** Save to a database */
                        /** Add to a spreadsheet, etc.... */
                      }}
                      updateFlag={updateSurveyData}
                      hideDot={true}
                    />
                  </div>
                </div>
              </>
            ) : null
          }
          {isEditable && (
            <div className="save-button mt-4">
              {isReadOnly ? "" : <Button text="Save" id="save" onClick={handleFollowUpSubmit}></Button>}
            </div>
          )}
        </div>
        <PreviousFollowUpPrint
          followUpData={printConsultant}
          servicesRendered={servicesRenderedPrint}
          appointmentType={appointmentType}
          patientDetail={patientDetail}
          componentRef={followUpPrintRef}
          templateJSON={signatureJson}
          smartSummaryData={smartSummaryData}
          vital={vitalsData}
          testLabels={testLabels}
          appointmentDate={appointmentDate}
        />
        {
          view && (
            <Modal size="xl" show={view} onHide={() => setView(false)}>
              <Modal.Header closeButton>
                Cancelled Lab Prescriptions
              </Modal.Header>
              <Modal.Body>
                <Box sx={{ width: "100%", marginTop: "20px" }}>
                </Box>
              </Modal.Body>
            </Modal >
          )
        }
      </div>
      {/* display all previous filled consultant notes irrespective of appointment type */}
      {!consultantRequest && (
        <PreviousFollowUpVisit
          patientDetail={patientDetail}
          appointmentId={appointmentDetails?.id}
          smartSummaryData={smartSummaryData}
          signatureJson={signatureJson}
        />
      )}
    </>
  )
}

export default FollowUpVisit
